import { CmsApiSupportContactFormBlockData } from 'modules/cms/api/types/CmsApiSupportContactForm';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpSupportContactFormBlock } from './CmsAmpSupportContactFormBlock';
import { CmsSupportContactFormBlock } from './CmsSupportContactFormBlock';

export const CmsSupportContactFormBlockMapping: CmsBlockMapping<CmsApiSupportContactFormBlockData> =
  {
    invariant: [],
    width: CmsBlockWidth.GRID,
    Component: CmsSupportContactFormBlock,
    AmpComponent: CmsAmpSupportContactFormBlock,
  };
